<template>
  <div class="page-container">

    <div class="content">
      <QueryParams ref="QueryParams" :loading="loading" :search-field="searchField" @search="queryData" />
      <div class="table-container" style="padding: 10px">
        <Table-filter
          title="明细"
          :show-custome="false"
          :rt-columns="rtColumns1"
          :lt-columns="ltColumns1"
          :grid-columns="gridOptions.columns"
          :count-data="countFileds"
          :all-options="allOptions"
          :pagination="pagination"
          @pagination-change="handleTablePaginationChange"
          @confirm="tableConfigConfirm"
        >
          <vxe-grid
            ref="xTable"
            v-loading="loading"
            class="table-block"
            border
            :highlight-hover-row="true"
            resizable
            height="300"
            align="center"
            size="mini"
            show-overflow
            :sort-config="{ multiple: true }"
            :empty-render="{name: 'NotData'}"
            :filter-config="{ remote: true }"
            :checkbox-config="{ highlight: true }"
            :radio-config="{ highlight: true }"
            :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
            :edit-config="{ trigger: 'manual', mode: 'row' }"
            :columns="gridOptions.columns"
            :data="gridOptions.data"
            :row-class-name="rowClassName"
            @filter-change="filterChangeEvt"
            @cell-dblclick="cellClick"
          />
        </Table-filter>
      </div>
    </div>

    <table-custom-filter ref="CustomFilter" :current-filter-field="currentFilterField" @confirm="customeFilter" />

  </div>
</template>

<script>
import { apiSapClientFindInfo } from '@/api/common'
import tableMixins from '@/utils/tableMixins'
import pageConfig, { pageSearch } from './config/ClientSelect'

// 接口入口
export default {
  mixins: [tableMixins],
  props: {
    mode: {
      type: String,
      default: undefined
    },
    isRadio: {
      type: Boolean,
      default: true
    },
    agents: {
      type: Array,
      default: () => []
    },
    validBlock: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      loading: false,
      pagination: {
        page: 1,
        pagesize: 50,
        totalCount: 0
      },
      gridOptions: {
        columns: [
          { type: 'radio', title: '', field: 'radio', width: 40 }
        ],
        data: []
      },
      tableData: [],
      pageSearch,
      searchField: {},
      isSetFilter: false
    }
  },
  computed: {},
  created() {
    if (!this.isRadio) {
      this.gridOptions.columns[0].type = 'checkbox'
    }
    this.initPage(pageConfig)
  },
  methods: {
    initPage(pageConfig) {
      const columns = []
      const searchField = {}
      const keys = Object.keys(pageConfig)
      keys.forEach(key => {
        const obj = {
          field: key,
          title: pageConfig[key].title,
          width: pageConfig[key].width || 120
        }
        if (pageConfig[key].slot) {
          obj.slots = {
            default: key
          }
        }
        // 该字段展示为描述
        if (pageConfig[key].describe) {
          obj.field += '_text'
        }
        columns.push(obj)

        if (pageConfig[key].type) {
          searchField[key] = pageConfig[key]
        }
      })

      if (Object.keys(this.pageSearch).length) {
        Object.assign(this.pageSearch, searchField)
        this.searchField = this.pageSearch
      } else {
        this.searchField = searchField
      }
      this.gridOptions.columns = this.gridOptions.columns.concat(columns)
    },
    async queryData(page, ranges) {
      if (page === 1) {
        this.pagination.page = page
        // 保存 查询组件的查询参数
        this.ranges = ranges
        this.handleRanges(ranges)
        // this.isSetFilter = false
      }
      const params = {
        partner: this.$store.getters.role.USER_BP,
        role: this.$store.getters.role.ROLE,
        ...this.allConditions,
        ...this.pagination,
        mode: this.mode,
        sort: this.sortData.concat(this.tableSort)
      }

      this.loading = true
      try {
        const { data, total } = await apiSapClientFindInfo(params)
        if (data.length === 0 && (total - 0)) {
          this.queryData(1, ranges)
          return
        }
        this.tableData = data
        this.gridOptions.data = data.map(v => v.info)
        this.pagination.totalCount = total - 0
      } catch (e) {
        //
      }
      this.loading = false
    },
    cellClick({ row, rowIndex, column }) {
      if (this.isRadio) {
        this.$refs.xTable.setRadioRow(row)
      } else {
      }
    },
    // 处理分页事件table
    handleTablePaginationChange(pageParams) {
      this.pagination = { ...this.pagination, ...pageParams }
      this.queryData()
    },
    // 用于弹窗提交时 回调数据
    submitForm() {
      // 给父组件返回promise对象用于回调
      return new Promise(resolve => {
        let selectData
        if (this.isRadio) {
          selectData = this.$refs.xTable.getRadioRecord()
          if (!selectData || selectData.block) {
            this.$message.error('该客户已经停用！')
            return resolve(undefined)
          }
          resolve(this.filterData(selectData))
        } else {
          selectData = this.$refs.xTable.getCheckboxRecords()
          if (!selectData.length) {
            return resolve(undefined)
          }
          resolve(selectData.map(this.filterData))
        }
      })
    },
    filterData(data) {
      data.customerCode = data.partner
      data.customerName = data.name_org1
      data.customerType = data.zzfld000016
      const { info, yxdy, address, high_yxdy } = this.tableData.find(item => {
        return item.info.partner === data.partner
      })
      return {
        ...info,
        orgList: [...yxdy],
        addressList: [...address],
        high_yxdy: [...high_yxdy]
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.form-query {
  /deep/ .el-form-item__content{
    display: inline-block;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dialog/ClientSelect.vue